const ProfileActions = {
  LOADING_PROFILE_DATA: 'LOADING_PROFILE_DATA',
  LOAD_PROFILE_DATA_SUCCESS: 'LOAD_PROFILE_DATA_SUCCESS',
  LOAD_PROFILE_DATA_FAILED: 'LOAD_PROFILE_DATA_FAILED',
  END_LOADING: 'END_LOADING',
  SET_USER_AVAILABILITY: 'SET_USER_AVAILABILITY',
  UPDATE_AVATAR_FAILED: 'UPDATE_AVATAR_FAILED',
  LOAD_PARSED_RESUME_DATA_SUCCESS: 'LOAD_PARSED_RESUME_DATA_SUCCESS',
  SET_PHONE_COUNTRY: 'SET_PHONE_COUNTRY'
};

export {
  ProfileActions
};
